export const defaultRowsPerPageOptions = [5, 10, 15, 25, 50]
export const defaultPageSize = 5
export const smallDefaultPageSize = 5
export const mediumDefaultPageSize = 10
